/**
 * Created by mongoose on 19/04/16.
 */
const constants = {
    VAT_VALUE: 0.1,
    PROMOTIONSLISTMODE: {
        ICONBUTTON: "ICON_BUTTON",
        SLIDESHOW: "SLIDESHOW",
    },
    RESOLUTION: {
        XXS: "320",
        XS: "360",
        SM: "768",
        MD: "1024",
        LG: "1280",
    },
    ENVIRONMENT: {
        PRODUCTION: "PRODUCTION",
        STAGING: "STAGING",
        DEVEL: "DEVEL",
    },
    DEFAULT_EXTRA_MEDIA: {
        url: "https://s3.eu-central-1.amazonaws.com/witbooking.static/img/hotel-bell-big.png",
        title: "",
        description: "",
        order: 1,
    },
    OCCUPANTS_TYPE: {
        SENIOR: "SENIOR",
        ADULT: "ADULT",
        TEENAGER: "TEENAGER",
        CHILDREN: "CHILD",
        BABY: "BABY",
    },
    OCCUPANTS_TYPE_COUNT: {
        CHILDREN: "childrenCount",
    },
    OCCUPANTS_FILTER_TYPE: {
        AGE: "age",
        OCCUPANTS_TYPE: "occupants_type",
        NONE: "none",
    },
    SERVICE_TYPE: {
        ROOM: "ROOM",
        UNIT: "UNIT",
        PERSON: "PERSON",
        PERCENTAGE: "PERCENTAGE",
    },
    CONFIGURATION_KEY: "configuration",
    PROPERTY_DATA_KEY: "propertyData",
    PROPERTY_ARI_KEY: "PROPERTY_ARI",
    PROPERTY_ARI_ALL_KEY: "PROPERTY_ARI_ALL",
    PROPERTY_STATUS: {
        AVAILABLE: "AVAILABLE",
        UNAVAILABLE: "UNAVAILABLE",
        RESTRICTED: "RESTRICTED",
    },
    BOOKABLE_STATUS: {
        AVAILABLE: "AVAILABLE",
        UNAVAILABLE: "UNAVAILABLE",
        RESTRICTED: "RESTRICTED",
        IGNORED_FILTER: "IGNORED_FILTER",
    },
    PROPERTY_TYPE: {
        HOTEL: "HOTEL",
        CHAIN: "CHAIN",
    },
    TOTAL_RATE: "totalRate",
    INVENTORY_MODE: {
        GROUPED: "grouped",
        LIST: "list",
    },
    BUCKETS: {
        CONFIGURATION: "configuration",
        MEALPLAN: "mealplan",
        CONDITION: "condition",
        ACCOMMODATION: "accommodation",
    },
    LOCAL_STORAGE_KEYS: {
        CART: "WB_WBV8-CART",
        ARI_REQUEST_PARAMS: "WB_WBV8-ARI_REQUEST_PARAMS",
        PROPERTY_ARI_REQUEST_PARAMS: "WB_WBV8-PROPERTY_ARI_REQUEST_PARAMS",
        RESERVATION_ID: "WB_WBV8-RESERVATION_ID",
        DEFERRED_RESERVATION_ID: "WB_WBV8-DEFERRED_RESERVATION_ID",
        SHOW_ON_UNAVAILABLE: "WB_WBV8-SHOW_ON_UNAVAILABLE",
        DEMO_MODAL_OPENED: "WBK_DEMO_MODAL_OPENED",
        WBK_ORIGIN: "WBK_ORIGIN",
        STAY_QUEUE: "STAY_QUEUE",
        STAY_QUEUE_DATE_IN: "STAY_QUEUE_DATE_IN",
        STAY_QUEUE_DATE_OUT: "STAY_QUEUE_DATE_OUT",
        STAY_QUEUE_INDEX: "STAY_QUEUE_INDEX",
        STAY_QUEUE_AGES: "STAY_QUEUE_AGES",
        HIDE_EXTRAS_MODAL: "HIDE_EXTRAS_MODAL",
        SESSION_ID: "SESSION_ID",
        CURRENCY: "CURRENCY",
        HEARTBEAT_LOYALTY_DATA: "HEARTBEAT_LOYALTY_DATA",
        HEARTBEAT_LAST_BOOKING_CART_DATA: "HEARTBEAT_LAST_BOOKING_CART_DATA",
    },
    FORM_FIELD_TYPES: {
        STRING: "string",
        NUMBER: "number",
        PHONE: "phone",
        PHONE_PREFIX: "phonePrefix",
        EMAIL: "email",
        BOOLEAN: "boolean",
        CREDIT_CARD_NUMBER: "creditCardNumber",
        CREDIT_CARD_CCV: "creditCardCCV",
    },
    MESSAGE_POSITIONS: {
        TOP_INVENTORY_STEP_1: "TOP_INVENTORY_STEP_1",
        BELOW_LOGO_STEP_1: "BELOW_LOGO_STEP_1",
        BELOW_PERSONAL_INFO_STEP_2: "BELOW_PERSONAL_INFO_STEP_2",
        TOP_METHOD_PAYMENT_STEP_2: "TOP_METHOD_PAYMENT_STEP_2",
        MODAL_STEP_1: "MODAL_STEP_1",
        MODAL_STEP_2: "MODAL_STEP_2",
    },
    SPECIAL_MESSAGE_TYPES: {
        OCCUPATION_MESSAGE: "OCCUPATION_MESSAGE",
        NO_RESULTS: "NO_RESULTS",
    },
    CONFIGURATION_OCCUPANTS: {
        SENIOR: "SENIOR",
        ADULT: "ADULT",
        TEENAGER: "TEENAGER",
        CHILD: "CHILD",
        BABY: "BABY",
    },
    STEP_PATHS: {
        HEALTH_CHECK: "health",
        STEP_1: "availability",
        STEP_2: "checkout",
        STEP_3: "booking-confirmation",
        STEP_4: "booking-modification",
        WIDGET: "widget",
        SHARE_BOOKING: "share-booking",
        RECOVER_RESERVATION_CONFIRMATION: "recover-reservation",
    },
    FUNNEL_VIRTUAL_PAGE: {
        STEP_1: "/step1",
        STEP_2: "/step2",
        STEP_3: "/step3",
        STEP_4: "/step4",
        CONFIRMATION: "/success",
    },
    MARKUP_PHASE: {
        STEP_1: "STEP1",
        STEP_2: "STEP2",
        STEP_3: "STEP3",
        STEP_4: "STEP4",
        ALL: "ALL",
    },
    MARKUP_TAG: {
        AMOUNT: "{{markup_amount}}",
        LANGUAGE: "{{markup_language}}",
        CURRENCY: "{{markup_currency}}",
        CHECK_IN: "{{markup_checkIn}}",
        CHECK_OUT: "{{markup_checkOut}}",
        PROPERTY_TICKER: "{{markup_establishment}}",
        RESERVATION_ID: "{{markup_reservationId}}",
        GUEST_NAME: "{{guestName}}",
        GUEST_SURNAME: "{{guestSurname}}",
        GUEST_COUNTRY_CODE: "{{guestCountryCode}}",
        GUEST_PHONE_COUNTRY_CODE: "{{guestPhoneCountryCode}}",
        GUEST_PHONE: "{{guestPhone}}",
        GUEST_EMAIL: "{{guestEmail}}",
        GUEST_ADDRESS: "{{guestAddress}}",
        GUEST_ID_DOCUMENT: "{{guestIdDocument}}",
        GUEST_ARRIVAL_TIME: "{{guestArrivalTime}}",
        GUEST_COMMENTS: "{{guestComments}}",
    },
    PAYMENT_TYPES: {
        CREDIT_CARD_VAULT: "CREDIT_CARD_VAULT",
        POS: "POS",
        TRANSFER: "TRANSFER",
        WITHOUT_CARD: "WITHOUT_CARD",
        RESERVATION_REQUEST: "RESERVATION_REQUEST",
        SIPAY_TOKENIZED_VAULT: "SIPAY_TOKENIZED_VAULT",
        PNP_TOKEN: "PNP_TOKEN",
        PAY_NO_PAIN_V2: "PAY_NO_PAIN_V2",
        PAY_NO_PAIN_PROXY: "PAY_NO_PAIN_PROXY",
        PAYPAL_EXPRESS_CHECKOUT: "PAYPAL_EXPRESS_CHECKOUT",
        STRIPE: "STRIPE",
        PCI_PROXY: "PCI_PROXY",
        ADDON_PAYMENTS: "ADDON_PAYMENTS",
        EXTERNAL_STORAGE: "EXTERNAL_STORAGE",
        WITBOOKING: "WITBOOKING",
        CREDIT_CARD_VAULT_EMERGENT: "CREDIT_CARD_VAULT_EMERGENT",
        MERCADO_PAGO: "MERCADO_PAGO",
        PAYPAL_EXPRESS_STANDARD: "PAYPAL_EXPRESS_STANDARD",
        PPR: "PPR",
        DEFERRED: "DEFERRED",
        CRIPTAN: "CRIPTAN",
    },
    PAYMENT_TYPES_OLD: {
        CREDIT_CARD_VAULT: "CREDIT_CARD_VAULT",
        CREDIT_CARD_GUARANTEE: "CREDIT_CARD_VAULT",
        CREDIT_CARD_GUARANTEE_VAULT: "CREDIT_CARD_VAULT",
        TPV: "POS",
        WIRE_TRANSFER: "TRANSFER",
        PCI_PROXY: "PCI_PROXY",
        TRANSFER: "TRANSFER",
        PAYPAL_EXPRESS_CHECKOUT: "PAYPAL_EXPRESS_CHECKOUT",
        PAYPAL: "PAYPAL_EXPRESS_CHECKOUT",
        MERCADOPAGO: "MERCADO_PAGO",
        TC_TOKEN: "PNP_TOKEN",
        STRIPE: "STRIPE",
        WITBOOKING: "WITBOOKING",
        PAYNOPAIN: "PNP_TOKEN",
        SIPAY_TOKENIZED_VAULT: "SIPAY_TOKENIZED_VAULT",
        POS: "POS",
        SIPAY_TOKENIZED_POS: "PPR",
        CREDIT_CARD_VAULT_EMERGENT: "CREDIT_CARD_VAULT_EMERGENT",
    },
    ERROR_TYPE: {
        SERVER_ERROR: "SERVER_ERROR",
    },
    ARI_VALUE_TYPE: {
        MAX_NOTICE: "MAX_NOTICE",
        MIN_NOTICE: "MIN_NOTICE",
        MAX_STAY: "MAX_STAY",
        MIN_STAY: "MIN_STAY",
        LOCK: "LOCK",
        AVAILABILITY: "AVAILABILITY",
        RATE: "RATE",
        OCCUPATION: "OCCUPATION",
        CHECK_IN_CHECK_OUT: "CHECK_IN_CHECK_OUT",
        VALIDITY: "VALIDITY",
        CONTRACT_PERIOD: "CONTRACT_PERIOD",
        CALENDAR: {
            UNAVAILABLE_FOR_WHOLE_RANGE: "UNAVAILABLE_FOR_WHOLE_RANGE",
        },
    },
    VIEWS: {
        LIST: "LIST",
        MAP: "MAP",
    },
    CREDIT_CARDS: {
        Visa: "Visa",
        MasterCard: "MasterCard",
        AmericanExpress: "AmericanExpress",
        Discover: "Discover",
        Jcb: "Jcb",
        Diners: "Diners",
        // CarteBleu: 'CarteBleu',
        PCI: "pci",
        COMODO_SECURE: "comodo_secure",
        UnionPay: "UnionPay",
    },
    ROOM_DENOMINATION: {
        UNITS: "UNITS",
        ROOMS: "ROOMS",
        APARTMENTS: "APARTMENTS",
        BUNGALOWS: "BUNGALOWS",
        CABINS: "CABINS",
        HOUSES: "HOUSES",
        SHIP_CABIN: "SHIP_CABIN",
        VILLAS: "VILLAS",
        BEDS: "BEDS",
    },
    TPV_TYPE: {
        REDSYS: "sermepa",
        CECA: "ceca",
    },
    FAVICON: "{{mediaRootUrl}}/{{propertyTicker}}/favicon.ico",
    PRICE_CALENDAR: {
        SHOW_ALL_PRICES: "showAllPrices",
        SHOW_SELECTED_DATE_PRICES: "showSelectedDatePrices",
        HIDE_ALL_PRICES: "hideAllPrices",
    },
    SHOW_PROMO_CODE: {
        COLLAPSED: "showPromoCodeCollapsed",
        HIDE: "hidePromoCode",
        EXPANDED: "showPromoCodeExpanded",
    },
    SHOW_CHECKOUT_FORM: {
        ON_CLICK_BUTTON: "onClickButton",
        DIRECT: "direct",
    },
    ACCOMMODATIONS_ORDER: {
        ASCENDING_PRICE: "ascendingPrice",
        LIST_POSITION: "listPosition",
    },
    OCCUPANT_RESTRICTION: {
        NONE: "NONE",
        TAKE_ALL_PEOPLE: "TAKE_ALL_PEOPLE",
        TAKE_ADULT_CHILD: "TAKE_ADULT_CHILD",
        TAKE_ADULT_CHILD_BABY: "TAKE_ADULT_CHILD_BABY",
        TAKE_ADULT_TEENAGER_CHILD: "TAKE_ADULT_TEENAGER_CHILD",
        TAKE_ADULT_TEENAGER_CHILD_BABY: "TAKE_ADULT_TEENAGER_CHILD_BABY",
        TAKE_SENIOR_ADULT_TEENAGER_CHILD_BABY: "TAKE_SENIOR_ADULT_TEENAGER_CHILD_BABY",
    },
    PAYMENT_STATUS: {
        SUCCESS: "success",
        FAILURE: "failure",
    },
    PENDING_AMOUNT_INFO_SECTION: {
        AMOUNT: "AMOUNT",
        TEXT: "TEXT",
    },
    PENDING_AMOUNT_TEXT_CONFIGURATION: {
        PAY_AT_ESTABLISHMENT: "PAY_AT_ESTABLISHMENT",
        PAY_AT_HOTEL: "PAY_AT_HOTEL",
        PENDING_PAYMENT: "PENDING_PAYMENT",
        PAY_ACCORDING_TO_CONDITIONS: "PAY_ACCORDING_TO_CONDITIONS",
        AMOUNT_REMAINING: "AMOUNT_REMAINING",
        NO_TEXT: "NO_TEXT",
    },
    DEVICE_SIZES: {
        MIN_WIDTH_TABLET_HORIZONTAL: 768,
    },
    RESERVATION_STATUS: {
        CONFIRMED: "reserva",
        PRE_RESERVATION: "prereserva",
        CANCELED: "cancelada",
        DEFERRED: "deferred",
    },
    RESERVATION_STATUS_EXTENDED: {
        UNCONFIRMED: "4",
    },
    PROPERTY_FILTER: {
        REPRESENTATION: {
            DROPDOWN: "DROPDOWN",
            RADIO: "RADIO",
            TAB: "TAB",
        },
        TYPE: {
            ESTABLISHMENT: "ESTABLISHMENT",
            INVENTORY: "INVENTORY",
            URL: "URL",
            PACKAGE: "PACKAGE",
            EXTRA: "EXTRA",
        },
        HOTEL_FILTER: "hotelFilter",
    },
    DEFAULT_HOST: "engine.witbooking.com",
    MODAL_TYPE: {
        CONDITION: "CONDITION",
        CANCELLATION: "CANCELLATION",
    },
    ROOM_REPRESENTATION_TYPE: {
        CAROUSEL: "CAROUSEL",
        HORIZONTAL: "HORIZONTAL",
    },
    ROOM_DETAIL_REPRESENTATION_TYPE: {
        EMBEDDED: "EMBEDDED",
        FULL: "FULL",
    },
    PAY_NO_PAIN: {
        BOOKING_ENGINE_CHARGE: "BOOKING_ENGINE_CHARGE",
    },
    ENTITY_TYPES: {
        SINGLE: "SINGLE",
        DOUBLE: "DOUBLE",
        MULTIPLE: "MULTIPLE",
    },
    FULL_WIDTH_TYPE: {
        FIXED_HEADER_AND_MINIFORM: "FIXED_HEADER_AND_MINIFORM",
        FIXED_MINIFORM: "FIXED_MINIFORM",
        FLOATING_MAP: "FLOATING_MAP",
    },
    MENU_MARKUP: "wbkMenu",
    MENU_BUTTON_MARKUP: "wbkMenuButton",
    EVENTS: {
        ENGINE_LOADED: "wbk_engineLoaded",
        START_STEP_ZERO: "wbk_startStepZero",
        START_STEP_ONE: "wbk_startStepOne",
        CONTINUE_STEP_ZERO: "wbk_continueStepZero",
        CONTINUE_STEP_ONE: "wbk_continueStepOne",
        CHECKED_AVAILABILITY: "wbk_checkedAvailability",
        CHANGED_BOOKING_FORM_CHAIN: "wbk_changedBookingFormChain",
        CHANGED_BOOKING_FORM: "wbk_changedBookingForm",
        NO_AVAILABILITY: "wbk_noAvailability",
        COMPARING_PRICES: "wbk_comparingPrices",
        EXPANDED_INVENTORY: "wbk_expandedInventory",
        ADDED_RESERVATION: "wbk_addedReservation",
        START_STEP_TWO: "wbk_startStepTwo",
        START_STEP_THREE: "wbk_startStepThree",
        CONTINUE_STEP_THREE: "wbk_continueStepThree",
        PAYMENT_ERROR: "wbk_paymentError",
        PAYMENT_MODAL: "wbk_paymentModal",
        START_CONFIRMATION: "wbk_startConfirmation",
        RESERVATION_RECEIPT: "wbk_reservationReceipt",
        RESERVATION_SUCCESS: "wbk_reservationSuccess",
        CHANGED_LANGUAGE: "wbk_changedLanguage",
        OPENED_SERVICES_MODAL: "wbk_openedServicesModal",
        CANCEL_RESERVATION: "wbk_cancelReservation",
    },
    PAYMENT_MODAL_PHASES: {
        START: "start",
        CONTINUE: "continue",
        ERROR: "error",
        CLOSE: "close",
    },
    SERVICES_EXPANDED: {
        EXPAND_DESKTOP: "expandDesktop",
        EXPANDED: "expanded",
        COLLAPSED: "collapsed",
    },
    ERROR_SCREEN: {
        NOT_FOUND: "NOT_FOUND",
        SERVER: "SERVER",
        OLD_BROWSER: "OLD_BROWSER",
    },
    SELECTION_BEHAVIOR: {
        DESKTOP_NEW_TAB: "DESKTOP_NEW_TAB",
        SAME_TAB: "SAME_TAB",
        NEW_TAB: "NEW_TAB",
    },
    LEGAL_INFO: {
        PRIVACY_POLICY: "PRIVACY_POLICY",
        COMMUNICATIONS_POLICY: "COMMUNICATIONS_POLICY",
    },
    DISPLAY_ELEMENT_TYPE: {
        INFO: "INFO",
        MAP: "MAP",
        AVAILABILITY: "AVAILABILITY",
        CUSTOM: "CUSTOM",
    },
    DISPLAY_CONDITION_TYPE: {
        ENTITY: "ENTITY",
        TICKER: "TICKER",
        ACTIVE: "ACTIVE",
        BOOKING_WINDOW: "BOOKING_WINDOW",
    },
    ACTIVE_ENTITY_TYPE: {
        HOTEL: "PROPERTY",
        CHAIN: "CHAIN",
        ACCOMMODATION: "ACCOMMODATION",
        PACKAGE: "PACKAGE",
    },
    HOTEL_CARD_SIZE: {
        LARGE: "LARGE",
        SMALL: "SMALL",
    },
    RESULT_HEADER_NATURE: {
        SMALL: "small",
        MEDIUM: "medium",
        LARGE: "large",
    },
    SELECT_BEHAVIOR_TYPE: {
        ACCOMMODATION: "ACCOMMODATION",
        PROPERTY: "PROPERTY",
        PACKAGE: "PACKAGE",
    },
    ACCOMMODATION_MODIFICATION_RESTRICTION_TYPE: {
        AMOUNT_GTE: "AMOUNT_GTE",
        NO_RESTRICTION: "NO_RESTRICTION",
    },
    DATES_MODIFICATION_RESTRICTION_TYPE: {
        AMOUNT_AND_STAY_GTE: "AMOUNT_AND_STAY_GTE",
        STAY_GTE: "STAY_GTE",
        AMOUNT_GTE: "AMOUNT_GTE",
        NO_RESTRICTION: "NO_RESTRICTION",
    },
    QUESTIONNAIRE_DEPENDER_TYPE: {
        EXTRA: "EXTRA",
        GUEST_FORM: "GUEST_FORM",
        CANCELLATION_FORM: "CANCELLATION_FORM",
    },
    CUSTOM_FORM_WIDGET_TYPES: {
        STAY_DATE: "STAY_DATE",
        CHECKBOX: "CHECKBOX",
        SELECT: "SELECT",
        INPUT: "INPUT",
    },
    ROOM_SELECTION_VIEW_TYPE: {
        LIST: "LIST",
        GRID: "GRID",
        GRID_MOBILE: "GRID_MOBILE",
    },
    DEVICE_TYPE: {
        DESKTOP: "DESKTOP",
        MOBILE: "MOBILE",
        TABLET: "TABLET",
    },
    METASEARCH: {
        TRIVAGO: "TRIVAGO",
        TRIPADVISOR: "TRIPADVISOR",
        GOOGLE: "GOOGLE",
    },
    CHANNEL: {
        TRIVAGO: "trivago",
        TRIPADVISOR: "tripadvisor",
        GOOGLE: "google",
    },
    OCCUPATION_ALTERNATIVES: "occupationsAlternatives",
    SHOW_OCCUPATION_ALTERNATIVES: {
        HIDE: "HIDE",
        COLLAPSED: "COLLAPSED",
        EXPANDED: "EXPANDED",
        NO_AVAILABILITY: "NO_AVAILABILITY",
    },
    PAYMENT_CONFIGURATION: {},
    OCCUPANTS_TYPE_ORDER: {},
    DATALAYER_EVENTS: {
        PROPERTY_SELECTION: {
            EVENT_CATEGORY: "Property",
            EVENT_ACTION: "Property selection start process",
            EVENT: "Property selection",
        },
        ACCOMMODATION_SELECTION: {
            EVENT_CATEGORY: "Accommodation",
            EVENT_ACTION: "Accommodation selection start process",
            EVENT: "Accommodation selection",
        },
        INVENTORY: {
            EVENT_CATEGORY: "Inventory",
            EVENT_ACTION: "Inventory selection start process",
            EVENT: "Inventory selection",
        },
        CHECKOUT: {
            EVENT_CATEGORY: "Checkout",
            EVENT_ACTION: "Checkout start process",
            EVENT: "Checkout",
        },
        RESERVATION_RECEIPT: {
            EVENT_CATEGORY: "Reservation receipt",
            EVENT_ACTION: "Reservation receipt start process",
            EVENT: "Reservation receipt",
        },
        RESERVATION_SUCCESS: {
            EVENT_CATEGORY: "Confirmation",
            EVENT_ACTION: "Confirmation start process",
            EVENT: "Confirmation",
        },
        SERVICES: {
            EVENT_CATEGORY: "Services",
            EVENT_ACTION: "Services start process",
            EVENT: "Services selection",
        },
        CANCEL_RESERVATION: {
            EVENT_CATEGORY: "Cancellation",
            EVENT_ACTION: "Cancellation start process",
            EVENT: "Cancellation",
        },
        CHANGED_BOOKING_FORM: {
            EVENT_CATEGORY: "Form",
            EVENT_ACTION: "Changed booking form",
            EVENT: "Form",
        },
    },
    DATE_SELECTION_TYPE: {
        NONE: "NONE",
        SPECIFIC: "SPECIFIC",
        ALL: "ALL",
    },
    TAXES_TEXT: {
        TAXES_INCLUDED: "TAXES_INCLUDED",
        TAXES_EXCLUDED: "TAXES_EXCLUDED",
        TAXES_AND_FEES_INCLUDED: "TAXES_AND_FEES_INCLUDED",
        TAXES_AND_FEES_EXCLUDED: "TAXES_AND_FEES_EXCLUDED",
        TAXES_INCLUDED_FEES_EXCLUDED: "TAXES_INCLUDED_FEES_EXCLUDED",
    },
    CITY_TAX_CONFIGURATION: {
        ADD_TO_ALL_STEPS: "ADD_TO_ALL_STEPS",
        EXCLUDE_BEFORE_CHECKOUT: "EXCLUDE_BEFORE_CHECKOUT",
        EXCLUDE_FROM_ALL_STEPS: "EXCLUDE_FROM_ALL_STEPS",
    },
    CRM_PROPERTY_STATUS: {
        PROG: "prog",
        LIVE: "live",
        CANCELLED: "cancelled",
        DEMO: "demo",
        FRONT_BLOCK: "front_block",
        BACK_BLOCK: "back_block",
        TOTAL_BLOCK: "total_block",
    },
    DEPOSIT_TEXT_CONFIGURATION: {
        NO_TEXT: "NO_TEXT",
        DEPOSIT_REQUIRED: "DEPOSIT_REQUIRED",
        ADVANCE_PAYMENT: "ADVANCE_PAYMENT",
        DEPOSIT_NOT_REQUIRED: "DEPOSIT_NOT_REQUIRED",
        NO_ADVANCE_PAYMENT: "NO_ADVANCE_PAYMENT",
    },
    PROMOTED_DISCOUNT_TYPE: {
        PERCENTAGE: "PERCENTAGE",
        CONSTANT: "CONSTANT",
    },
    DEPOSIT_STATUS: {
        NONE: "NONE",
        PRE_PAY: "PRE_PAY",
        PAID: "PAID",
    },
};
if (process && process.env.NODE_ENV === "production") {
    constants.PAYMENT_CONFIGURATION = {
        [constants.PAYMENT_TYPES.WITBOOKING]: {
            domain: "https://secure.witbooking.com",
        },
    };
}
else {
    constants.PAYMENT_CONFIGURATION = {
        [constants.PAYMENT_TYPES.WITBOOKING]: {
            domain: "https://securedev.witbooking.com",
        },
    };
}
constants.OCCUPANTS_TYPE_ORDER = [
    constants.OCCUPANTS_TYPE.SENIOR,
    constants.OCCUPANTS_TYPE.ADULT,
    constants.OCCUPANTS_TYPE.TEENAGER,
    constants.OCCUPANTS_TYPE.CHILDREN,
    constants.OCCUPANTS_TYPE.BABY,
];
export default constants;
export const ROUTER_REDUCER_MOUNTPOINT = "routing";
export const REDUX_ASYNC_CONNECT_MOUNTPOINT = "reduxAsyncConnect";
export const BOOKING_FORM_NAME_MOUNTPOINT = "bookingForm";
export const CUSTOMER_FORM_NAME_MOUNTPOINT = "customerForm";
export const CC_FORM_NAME_MOUNTPOINT = "ccForm";
export const CHECKOUT_FORM_NAME_MOUNTPOINT = "checkoutForm";
// export const DEV_API_URL = 'http://localhost:9080/api';
export const DEV_API_URL = "http://91.121.184.5:9080/api";
// export const DEV_API_URL = "https://witbookerapistaging.witbooking.com/api";
// export const DEV_API_URL = "https://witbookingapi.witbooking.com/api";
// export const DEV_API_URL = 'https://witbookingapiclone.witbooking.com/api';
export const PROXY_DEV_API_URL = `http://localhost:${process.env.PORT}/PREFIX_PLACEHOLDER`;
/* FOR LUKE */
// export const API_URL = 'http://localhost:9080/api';
// export const PROXY_API_URL = 'http://91.121.184.5:8081/api';
/* FOR SHOWCASE */
export const API_URL = "https://witbookingapiclone.witbooking.com/api";
export const PROXY_API_URL = "https://engine.witbooking.com/PREFIX_PLACEHOLDER";
/* FOR LOCAL */
// export const API_URL = 'http://localhost:9080/api';
// export const PROXY_API_URL = 'http://localhost:8081/api';
export const PROPERTY_CONFIGURATION_PREFIX = "/api-property-configuration";
export const PROPERTY_DATA_PREFIX = "/api-property-data";
export const PROPERTY_ARI_PREFIX = "/api-property-ari";
